import React, { useState } from "react";

import {
  Text,
  Group,
  Box,
  Checkbox,
  TextInput,
  ActionIcon,
  createStyles,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { ArrowRight } from "tabler-icons-react";

const useStyles = createStyles(() => ({}));

export default function FlexibleList({ data, formatted_price, selectedBundle, selectedFlexible, currency, setSelectedFlexible }) {
  const smallScreen = useMediaQuery("(max-width: 768px)");
  const { theme } = useStyles();

  const [otherValue, setOtherValue] = useState("");
  
  if (!Array.isArray(data)) {
    return null;
  }
  const ensure2Dec = (value) => {
    value = value ? parseFloat(value) : 0;
    return value.toFixed(2).replace(".00", "");
  };
  const getPaymentDetailsFlexible = (item) => {
    if (item.frequency == "once" || item.frequency == "" || item.frequency == null) {
      return "";
    } else {
      return item.frequency.replace("per", "/");
    }
  };
  return (
    <>
      {data.map((price, index) => {
        const isChecked = selectedFlexible?.id === price.id;
        const amountTitle = Array.isArray(formatted_price) ? formatted_price[index]?.content : "";
        return (
          <Box mt={20}>
            <Checkbox
              radius="xl"
              styles={styles.checkbox}
              color={selectedBundle ? "gray" : null}
              label={
                <Box>
                  <Group position="apart" noWrap sx={styles.labelGroup}>
                    <Text>{amountTitle}</Text>
                    {price?.amount ? (
                      <Text>{`${currency}${ensure2Dec(price.amount)} ${getPaymentDetailsFlexible(price)}`}</Text>
                    ) : (
                      <TextInput
                        id={`other-value-${index}`}
                        value={otherValue}
                        styles={{
                          root: { width: smallScreen ? "100%" : "80px" },
                          input: { textAlign: "right" }
                        }}
                        onChange={(event) => setOtherValue(event.currentTarget.value)}
                        rightSection={
                          <ActionIcon
                            size={25}
                            radius="xl"
                            color={theme.primaryColor}
                            variant="filled"
                            disabled={otherValue === ""}
                          >
                            <ArrowRight
                              size={42}
                              strokeWidth={2}
                              color="white"
                              onClick={() => {
                                setSelectedFlexible({ ...price, otherPrice: parseFloat(otherValue) });
                              }}
                            />
                          </ActionIcon>
                        }
                      />
                    )}
                  </Group>
                  {typeof price.description === "string" && (
                    <Text color="dimmed" size="xs">
                      {price.description}
                    </Text>
                  )}
                </Box>
              }
              checked={isChecked}
              onClick={() => {
                if (!isChecked) {
                  if (price.amount) {
                    setSelectedFlexible(price);  
                  } else if (otherValue !== "") {
                    setSelectedFlexible({ ...price, otherPrice: parseFloat(otherValue) });
                  }
                }
              }}
            />
          </Box>
        );
      })}
    </>
  );
};

const styles = {
  checkbox: {
    label: { width: "100%" },
    root: {
      display: "flex",
      alignItems: "flex-start",
    },
    input: { marginTop: 2 },
    icon: { marginTop: 9 }
  },
  labelGroup: {
    display: "flex",
    alignItems: "flex-start"
  }
};
